export const SET_SNACKBAR = "SET_SNACKBAR";
export const SET_LOADING = "SET_LOADING";
export const CLEAR_LOADING = "CLEAR_LOADING";
